import { render, staticRenderFns } from "./UkrposhtaShow.vue?vue&type=template&id=3f950b90&scoped=true"
import script from "./UkrposhtaShow.vue?vue&type=script&lang=js"
export * from "./UkrposhtaShow.vue?vue&type=script&lang=js"
import style0 from "./UkrposhtaShow.vue?vue&type=style&index=0&id=3f950b90&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f950b90",
  null
  
)

export default component.exports